module.exports = __webpack_public_path__ + "static/media/scooter-item.fb95dd0a.png";